module.exports = __webpack_public_path__ + "img/illustration_en.030d85ae.png";